import { librarySearchReferencesCommand } from './searchReferencesCommand';
import { libraryListReferencesCommand } from './listReferencesCommand';
import { libraryInsertCitationCommand } from './insertCitationCommand';
import { searchPdfContentCommand } from './searchPdfContentCommand';

export const libraryCommands = [
  librarySearchReferencesCommand,
  libraryListReferencesCommand,
  libraryInsertCitationCommand,
  searchPdfContentCommand
];

export {
  librarySearchReferencesCommand,
  libraryListReferencesCommand,
  libraryInsertCitationCommand,
  searchPdfContentCommand
};

